export const isWorkshopHighlighted = (
  filteredWorkshopIds: string[] | undefined,
  workshopId: string,
): boolean => {
  if (!filteredWorkshopIds) return true;
  return filteredWorkshopIds?.includes(workshopId);
};
